import { render, staticRenderFns } from "./useStatistics.vue?vue&type=template&id=4092edc8&scoped=true&"
import script from "./useStatistics.vue?vue&type=script&lang=js&"
export * from "./useStatistics.vue?vue&type=script&lang=js&"
import style0 from "./useStatistics.vue?vue&type=style&index=0&id=4092edc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4092edc8",
  null
  
)

export default component.exports